import { render, staticRenderFns } from "./TransferType.vue?vue&type=template&id=236c3c57&scoped=true"
import script from "./TransferType.vue?vue&type=script&lang=js"
export * from "./TransferType.vue?vue&type=script&lang=js"
import style0 from "./TransferType.vue?vue&type=style&index=0&id=236c3c57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c3c57",
  null
  
)

export default component.exports